import { Card, CardBody } from "@datapay-by-datacom/design-system";
import type { GroupAnalyticsOverviewResponse } from "../../../generated/core-api";
import { formatNumber } from "../../../analytics/utils/formatters";
import styles from "./GroupOverviewCards.module.css";

interface KpiItemProps {
  label: string;
  value: number;
  accent?: string;
}

function KpiItem({ label, value, accent }: KpiItemProps) {
  return (
    <Card>
      <CardBody>
        <div className={styles.kpiItem}>
          <span className={styles.kpiLabel}>{label}</span>
          <span className={styles.kpiValue} style={accent ? { color: accent } : undefined}>
            {formatNumber(value)}
          </span>
        </div>
      </CardBody>
    </Card>
  );
}

export interface GroupOverviewCardsProps {
  data: GroupAnalyticsOverviewResponse;
}

export function GroupOverviewCards({ data }: GroupOverviewCardsProps) {
  return (
    <div className={styles.kpiGrid}>
      <KpiItem label="Members" value={data.total_members} />
      <KpiItem label="Workspaces" value={data.total_workspaces} />
      <KpiItem label="Threads" value={data.total_threads} />
      <KpiItem label="Active Users" value={data.active_users} accent="#6366f1" />
    </div>
  );
}
